import { Component } from 'vue';
import Lang from '@/modules/core/app/services/Lang';
import ProbateCalculatorFactory from '@/modules/tax/services/ProbateCalculatorFactory';
import { PredefinedJurisdiction } from '@/modules/predefined/enums/PredefinedJurisdiction';
import { CalculatorType } from '@/modules/tax/constants/CalculatorType';
import DiagnosticToolLaunchView from '@/modules/typeform/components/presentational/DiagnosticToolLaunchView.vue';
import { ToolsKey } from '@/modules/admin/constants/ToolsKey';
import { AuthUserPermission } from '@/modules/auth/models/AuthUserPermission';
import LightDiagnosticLandingView from '@/modules/lightdiagnostic/components/presentational/LightDiagnosticLandingView.vue';
import FinalTaxesCalculatorView from '@/modules/tax/components/presentational/finaltaxescalculator/FinalTaxesCalculatorView.vue';

type ToolsPanelItem = {
  key: string;
  title: string;
  subtitle: string;
  component: Component;
  isVisible?: (permission?: AuthUserPermission) => boolean;
};

export const ToolsPanelItems: ToolsPanelItem[] = [
  {
    key: ToolsKey.ONTARIO_PROBATE_CALCULATOR,
    get title(): string {
      return Lang.t('tax.ontario-probate-calculator');
    },
    get subtitle(): string {
      return Lang.t('tax.enter-generate-probate');
    },
    component: ProbateCalculatorFactory.build(PredefinedJurisdiction.ONTARIO)
  },
  {
    key: ToolsKey.CALIFORNIA_PROBATE_FEE_CALCULATOR,
    get title(): string {
      return Lang.t('tax.california-probate-calculator');
    },
    get subtitle(): string {
      return Lang.t('tax.enter-generate-probate');
    },
    component: ProbateCalculatorFactory.build(PredefinedJurisdiction.CALIFORNIA)
  },
  {
    key: ToolsKey.CALIFORNIA_PROBATE_BOND_CALCULATOR,
    get title(): string {
      return Lang.t('tax.california-bond-calculator');
    },
    get subtitle(): string {
      return Lang.t('tax.enter-generate-probate');
    },
    component: ProbateCalculatorFactory.build(
      PredefinedJurisdiction.CALIFORNIA,
      CalculatorType.BOND
    )
  },
  {
    key: ToolsKey.BC_PROBATE_FEE_CALCULATOR,
    get title(): string {
      return Lang.t('tax.bc-probate-calculator');
    },
    get subtitle(): string {
      return Lang.t('tax.enter-generate-probate');
    },
    component: ProbateCalculatorFactory.build(PredefinedJurisdiction.BRITISH_COLUMBIA)
  },
  {
    key: ToolsKey.ESTATE_PLAN_DIAGNOSTIC,
    get title(): string {
      return Lang.t('estate.estate-plan-diagnostic');
    },
    get subtitle(): string {
      return Lang.t('estate.diagnostic-questions-plan');
    },
    component: DiagnosticToolLaunchView,
    isVisible: (permission?: AuthUserPermission): boolean =>
      permission?.canAccessEstateDiagnosticTool ?? false
  },
  {
    key: ToolsKey.FINAL_TAXES_CALCULATOR,
    get title(): string {
      return Lang.t('tax.final-taxes-calculator');
    },
    get subtitle(): string {
      return Lang.t('tax.final-taxes-calculator-subtitle');
    },
    // TODO: @Thenu create View for final taxes calculator
    component: FinalTaxesCalculatorView,
    isVisible: (permission?: AuthUserPermission): boolean =>
      permission?.canAccessFinalTaxesCalculatorTool ?? false
  },
  {
    key: ToolsKey.ESTATE_LIGHT_DIAGNOSTIC,
    get title(): string {
      return Lang.t('estate.take-the-quiz');
    },
    get subtitle(): string {
      return Lang.t('estate.determine-the-best');
    },
    component: LightDiagnosticLandingView,
    isVisible: (permission?: AuthUserPermission): boolean =>
      permission?.canAccessLidaapStandalone ?? false
  }
  // {
  //   get title(): string {
  //     return Lang.t('estate.estate-expenses');
  //   },
  //   get subtitle(): string {
  //     return Lang.t('estate.expenses-estimation-settling');
  //   },
  //   component: ConversationViewSkeleton
  // }
];
